import React, { useEffect, useLayoutEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { getViewer } from "types/gql-types";
import { Modal } from "components/haven-design";
import { VIEWER_QUERY } from "components/auth/query";
import theme from "components/theme";
import { useSnackbar } from "components/haven-design/snackbar";
import LoginModalContext from "../context/modal";
import { HavenConnectLoginLogo } from "./shared-components";
import LoginCard from "./login-card";

const createVerifyEffect = <T, >(
  openSnackbar: (args: T) => void,
  setShowSignUp: React.Dispatch<React.SetStateAction<boolean>>,
) => () => {
  const query = new URLSearchParams(window.location.search);
  if (query.has("verify")) {
    openSnackbar({ message: "Successfully Verified Email", status: "success", duration: 5000 } as unknown as T);
    const url = new URL(window.location.href);
    url.searchParams.delete("verify");
    url.searchParams.delete("is-signup");
    setShowSignUp(false);
    window.history.pushState({}, "", url);
  }
};

const closeModalOrReload = () => {
  const query = new URLSearchParams(window.location.search);
  if (query.has("is-signup") || query.has("is-login")) {
    const url = new URL(window.location.href);
    url.searchParams.delete("is-signup");
    url.searchParams.delete("is-login");
    window.history.pushState({}, "", url);
  } else {
    window.location.reload();
  }
};


export const LoginModal: React.FC<{isSignup?: boolean}> = ({ isSignup = false }) => {
  const navigate = useNavigate();
  const { loading, error, data, refetch } = useQuery<getViewer>(VIEWER_QUERY);
  const [showSignup, setShowSignUp] = React.useState(isSignup);
  const [isOpen, setOpen] = useState(true);
  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    if (data && data.viewer) {
      setOpen(false);
      if (data.viewer.isClient) {
        closeModalOrReload();
      } else {
        navigate("/");
      }
    }
  }, [loading, data, error]);

  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  useLayoutEffect(createVerifyEffect(openSnackbar, setShowSignUp), []);

  return (
    <Modal
      title={<HavenConnectLoginLogo dark />}
      isNotCloseable={!isMobile}
      maxWidth="xs"
      isOpen={isOpen}
      fullScreen
      onRequestClose={(...args: unknown[]) => {
        const reason = args[1] as string | undefined;
        if (reason === "backdropClick") return;
        navigate(-1);
      }}>
      <div>
        <LoginModalContext.Provider value={{ inModal: true }}>
          <LoginCard afterLogin={() => refetch()} isSignup={showSignup} />
        </LoginModalContext.Provider>
      </div>
    </Modal>
  );
};
